<template>
  <div class="grid sm:grid-cols-4 grid-rows-2 h-full w-full">
    <div class="mt-lg col-start-2 col-end-4 row-start-1 row-end-2 bg-notFound bg-no-repeat bg-center bg-contain w-full h-full"></div>
    <div class="col-start-2 col-end-4 row-start-2 row-end-3 flex flex-col m-auto items-center">
      <h2 class="mt-lg text-darkFont w-4/5 text-18 md:text-24 lg:text-34">{{ $t('functional.notFound') }}</h2>
      <PublicPageSubmitButton
          v-if="$store.getters['auth/isAuthenticated']"
          :text="$t('functional.home')"
          @click="$router.push('/')"
          size="small"
          category="tertiary"
          data-ec="error_page_not_found"
          data-et="home_button"
      />
      <PublicPageSubmitButton
          v-else
          :text="$t('functional.login')"
          @click="$router.push('/login')"
          size="small"
          category="tertiary"
          data-ec="error_page_not_found"
          data-et="go_to_login_button"
      />
    </div>
  </div>
</template>

<script>
import PublicPageSubmitButton from '@/components/tailwind/publicPages/PublicPageSubmitButton.vue';

export default {
  name: 'NotFound',
  components: {
    PublicPageSubmitButton,
  },
};
</script>

